export function Footer() {
  return (
    <footer className="bg-black border-t border-gray-800 py-6 px-4 mt-auto">
      <div className="max-w-7xl mx-auto text-center space-y-2">
        <p className="text-gray-400 text-[10px] font-mono">
          © {new Date().getFullYear()} — Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
